import useStyles from "./styles"
// eslint-disable-next-line import/no-cycle
import AutocompleteSearch from ".."
import { GroupByName, sortBrands } from "../../../lib/helper/brandHelper"
import { removeTrailingSlash } from "../../../lib/helper/commonHelper"
import { useLanguage } from "../../../lib/hooks/languageHooks"
import { strings as Localization } from "../../../lib/Localization"
import { useSearchQuery } from "../../../redux/hook/searchHooks"
import { setSearchQuery } from "../../../redux/searchReducer"
import { useGetBrandsQuery } from "../../../redux/services/productInfoApi"
import { setShowNavbarSearch } from "../../../redux/settingsReducer"
import { useGetModelsQuery } from "../../../redux/services/broditWebApi"
import { sortModels } from "../../../lib/helper/modelHelper"
import { useLocation } from "react-router-dom"
// eslint-disable-next-line import/no-extraneous-dependencies
import { Redirect, useRouteMatch } from "react-router"
import { useDispatch } from "react-redux"
import React, { useEffect, useState } from "react"
import { PhoneAndroid } from "@material-ui/icons"
import { Box, useMediaQuery } from "@material-ui/core"

function DeviceSearchbar(props) {
    const classes = useStyles()
    const [redirect, setRedirect] = useState(false)
    const { url } = useRouteMatch()
    const location = useLocation()
    const [showModelSelection, setShowModelSelection] = useState(true)
    const dispatch = useDispatch()
    const deviceSearchbarSearchQuery = useSearchQuery("deviceSearchbar")
    const language = useLanguage()
    const { data: brands } = useGetBrandsQuery({ language })
    const { data: allModels } = useGetModelsQuery({ language })
    const isVerySmall = useMediaQuery(theme => theme.breakpoints.down(400))

    const hideSearch = () => {
        dispatch(setShowNavbarSearch(false))
    }

    const brandTypesNames = [
        "Handhelds",
        "Mobilephones",
        "Multimedia",
        "Navigation",
        "Twowayradio",
        "Other"
    ]

    const availableBrands = (brands ?? []).filter(
        brand => brandTypesNames.includes(brand.brandType.name)
    )
    const availableBrandOptions = GroupByName(availableBrands)
    const selectedBrandOptions = availableBrandOptions.filter(
        brandOption => deviceSearchbarSearchQuery?.brands?.includes(brandOption.name)
    )

    const availableModels = (allModels ?? []).filter(
        model => selectedBrandOptions
            .map(brandObj => brandObj.name)
            .includes(model.brand)
    )
    const availableModelOptions = GroupByName(availableModels)
    const selectedModelOptions = availableModelOptions.filter(
        modelOption => deviceSearchbarSearchQuery?.models?.includes(modelOption.name)
    )

    useEffect(() => {
        if (deviceSearchbarSearchQuery?.brands?.includes(Localization.otherModels)) {
            // We've selected brand "," so we hide the model selection.
            setShowModelSelection(false)
            setRedirect(true)
            hideSearch()
        } else {
            setShowModelSelection(true)
        }
    }, [deviceSearchbarSearchQuery?.brands])

    useEffect(() => () => {
        setRedirect(false) // Reset redirect on leave
    })

    const handleChangeBrands = (_event, newSelectedOptions) => {
        const brandName = newSelectedOptions?.[0]?.name

        dispatch(setSearchQuery({
            type: "deviceSearchbar",
            value: {
                ...(brandName) ? { brands: [brandName] } : {}
            },
            clearFilter: true
        }))
    }

    const handleChangeModels = (_event, newSelectedOptions) => { // TODO: Combine with handleChangeBrands
        if (!deviceSearchbarSearchQuery?.brands) return

        const modelName = newSelectedOptions?.[0]?.name

        dispatch(setSearchQuery({
            type: "deviceSearchbar",
            value: {
                brands: deviceSearchbarSearchQuery.brands,
                ...(modelName) ? { models: [modelName] } : {}
            },
            clearFilter: true
        }))

        if (modelName && modelName.length > 0) {
            dispatch(setShowNavbarSearch(false))
            setRedirect(true)
        }
    }

    const urlToFilterPage = () => `${removeTrailingSlash(url)}/filter`

    return (
        <Box style={{ display: "flex", flexDirection: "column" }} {...props}>
            {
                redirect && location.pathname !== urlToFilterPage()
                && <Redirect to={urlToFilterPage()} />
            }

            <Box
                id="device-searchbar"
                style={{ display: "flex", alignItems: "flex-end", gap: 10 }}
            >
                <PhoneAndroid />
                <AutocompleteSearch
                    className={classes.fieldMargin}
                    style={{ flexGrow: 1 }}
                    id="device-autocomplete-search"
                    // eslint-disable-next-line max-len
                    placeholder={(isVerySmall ? Localization.device : Localization.searchOnDevice).toUpperCase()}
                    options={sortBrands(availableBrandOptions)}
                    // filterOptions={filterOptions}
                    onChange={handleChangeBrands}
                    selectedOptions={selectedBrandOptions}
                />
            </Box>
            {
                selectedBrandOptions.length > 0 && showModelSelection
                && (
                    <Box
                        id="device-model-searchbar"
                        style={{ display: "flex", alignItems: "flex-end", gap: 10 }}
                    >
                        <AutocompleteSearch
                            className={classes.fieldMargin}
                            style={{ flexGrow: 1 }}
                            id="device-model-autocomplete-search"
                            placeholder={Localization.searchOnModel}
                            options={sortModels(availableModelOptions)}
                            onChange={handleChangeModels}
                            selectedOptions={selectedModelOptions}
                        />
                    </Box>
                )
            }
        </Box>
    )
}

export default DeviceSearchbar
